import { useMemo } from 'react'
import s from './TooltipActions.scss'
import cn from 'classnames'

const TooltipActions = ({ laneId, cards, toggleFollowupModal, toggleFollowupDateModal }) => {
  const restrictions = useMemo(() => {
    const canFollowUpDate = [
      'NEW',
      'PLOTTING',
      'REVIEWADDENDUM',
      'BIDLIST',
      'REVIEWESTIMATE',
      'APPROVEDESTIMATE'
    ].includes(laneId)
    const canSetBidDueDate = [
      'FOLLOWUP',
      'PAUSEDFOLLOWUP',
      'CONTRACTORAWARDED',
      'YY',
      'YN',
      'NN',
      'BOOMERANG'
    ].includes(laneId)
    const hasSelection = cards.some(card => card.selected)

    return {
      canFollowUpDate,
      canSetBidDueDate,
      hasSelection
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [laneId, cards])
  return (
    <div
      className={cn(s.actionsWrapper, {
        [s.disabled]: !restrictions.hasSelection
      })}
    >
      <span>
        <b>Actions</b>
      </span>
      <hr />
      {/* <p
        className={cn({
          [s.disabled]: restrictions.canSetBidDueDate
        })}
      >
        Set Bid Due Date
      </p> */}
      <p
        className={cn({
          [s.disabled]: restrictions.canFollowUpDate
        })}
        onClick={
          restrictions.canFollowUpDate || !restrictions.hasSelection
            ? null
            : toggleFollowupDateModal
        }
      >
        Set Follow-up Date
      </p>
      {/* <p>Schedule a Task</p>
      <p>Add a Note</p> */}
      <hr />
      <p onClick={restrictions.hasSelection ? toggleFollowupModal : null}>Follow-up by Email</p>
      {/* <hr />
      <p>Opportunity Manager...</p>
      <p>Client Bid Stage...</p>
      <p>Internal Bid Status...</p>
      <p>Opportunity Size...</p>
      <p>Opportunity Category...</p> */}
    </div>
  )
}

export default TooltipActions
